const b1 = 4 / 11,
  b2 = 6 / 11,
  b3 = 8 / 11,
  b4 = 3 / 4,
  b5 = 9 / 11,
  b6 = 10 / 11,
  b7 = 15 / 16,
  b8 = 21 / 22,
  b9 = 63 / 64,
  b0 = 1 / b1 / b1;

export function easeBounceOut(t: number): number {
  const _t = +t;

  return _t < b1
    ? b0 * t * t
    : t < b3
    ? b0 * (t -= b2) * t + b4
    : t < b6
    ? b0 * (t -= b5) * t + b7
    : b0 * (t -= b8) * t + b9;
}

export function expIn(t: number): number {
  return Math.pow(2, 10 * t - 10);
}

export function expOut(t: number): number {
  return 1 - Math.pow(2, -10 * t);
}

export function expInOut(t: number): number {
  const _t = (t *= 2);
  return (
    (_t <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2
  );
}

// easing:
const inOutQuad = (n: number): number => {
  n *= 2;
  if (n < 1) {
    return 0.5 * n * n;
  }
  return -0.5 * (--n * (n - 2) - 1);
};

export const scrollToTarget = (
  target: HTMLElement,
  duration: number,
  offset: number
): Promise<void> => {
  return new Promise<void>((resolve: any) => {
    let start: any = undefined;
    let end: any = undefined;
    let animationReq: number;
    const viewport = document.scrollingElement || document.documentElement;
    const scroll = (timestamp: number) => {
      const now = timestamp;

      if (!start) {
        start = timestamp;
        end = timestamp + duration;
      }

      const elRect = target.getBoundingClientRect();
      const topInView = elRect.top > offset;

      if (!topInView && viewport) {
        const progress = inOutQuad((now - start) / duration);
        viewport.scrollTop -= progress * window.innerHeight;
        animationReq = window.requestAnimationFrame(scroll);
      } else {
        window.cancelAnimationFrame(animationReq);
        resolve();
      }
    };

    animationReq = window.requestAnimationFrame(scroll);
  });
};
